var exports = {
  "kL": "x31de4314--a903ad--container",
  "Ew": "x31de4314--a903ad--notification",
  "BJ": "x31de4314--a903ad--calendar",
  "VN": "x31de4314--a903ad--close",
};

module.exports = exports;
